export default __webpack_public_path__ + "static/media/s-ramseiers-wei-go-grase.ea57c7b0.png";